import { render } from "./BidsWaitList.vue?vue&type=template&id=c7a0c69c&scoped=true&ts=true"
import script from "./BidsWaitList.vue?vue&type=script&lang=ts"
export * from "./BidsWaitList.vue?vue&type=script&lang=ts"

import "./BidsWaitList.vue?vue&type=style&index=0&id=c7a0c69c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a0c69c"]])

export default __exports__